module.exports = __webpack_public_path__ + "cdec083559dd8790049bc8005525281a.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/opher-vishnia.jpg
// module id = 675
// module chunks = 0